import { Button } from './Button'
import { cn } from './cn'

export interface ErrorStateProps {
  /** 表示メッセージ。既定「読み込みに失敗しました」 */
  message?: string
  /** 再試行ハンドラ。未指定なら再試行ボタンを表示しない（取得 Hook の refetch を渡す想定） */
  onRetry?: () => void
  className?: string
}

// 既存の `bg-red-50` エラーバナーの体裁を踏襲。role=alert で即時読み上げ。
/** エラー表示＋再試行導線の共通プリミティブ。 */
export function ErrorState({
  message = '読み込みに失敗しました',
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        'bg-red-50 border border-red-200 rounded-lg p-4 text-center text-red-700',
        className,
      )}
    >
      <p>{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry} className="mt-3">
          再試行
        </Button>
      )}
    </div>
  )
}
